import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodCcGenericLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4420_441)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4420_441)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 8,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 8,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 7.5,
				y: 8,
				width: 2,
				height: 7,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 10.5,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 10.5,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 13,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 13,
				width: 3,
				height: 2,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 6,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 14,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 18,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 20,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 26,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 28,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 30,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 34,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 36,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 38,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 40,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "black",
				fillOpacity: .64
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4420_441",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .02 }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopOpacity: .08
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4420_441",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodCcGenericLight;
